module.exports = __webpack_public_path__ + "static/media/12.1ca71e0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan-four/12.jpg
// module id = 442
// module chunks = 0